import React from "react";
import { Text, View, StyleSheet, Platform } from "react-native";
import moment from "moment";

import { hasItems, pluralize } from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";
import IntegrationUpdatedTime from "../common/IntegrationUpdatedTime";

export default function IntegrationItemDetails({ controller, type, item = {} }) {
  //const { accounts, last_updated } = item;

  let last_updated = null;
  const accounts = controller.getDevices(item.id);
  let connected = false;
  accounts.forEach((d) => {
    if (last_updated == null || d.last_updated > last_updated) last_updated = d.last_updated;
    if (d.isConnected) connected = true;
  });

  return (
    <View style={styles.row}>
      {hasItems(accounts) ? (
        <Text style={styles.text}>
          {pluralize("account", accounts.length)} •{" "}
        </Text>
      ) : null}
      <IntegrationUpdatedTime controller={controller} time={last_updated} connected={connected} useLargeText />
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  text: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
});
